import { useTranslation } from "react-i18next";
import { lt } from "../localize";
import type { LessonStage } from "../types";

interface StageTheoryProps {
  stage: LessonStage;
}

export const StageTheory = ({ stage }: StageTheoryProps) => {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">{lt(stage.title, lang)}</h2>
      <p className="text-sm text-muted-foreground leading-relaxed">
        {lt(stage.content, lang)}
      </p>

      {stage.keyPoints && stage.keyPoints.length > 0 && (
        <div className="space-y-2">
          {stage.keyPoints.map((point, i) => {
            const text = lt(point, lang);
            const [title, ...rest] = text.split(" — ");
            const desc = rest.join(" — ");
            return (
              <div key={i} className="glass p-3.5">
                <div className="text-sm">
                  <span className="font-semibold text-foreground">{title}</span>
                  {desc && (
                    <span className="text-muted-foreground"> — {desc}</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
